import React from 'react'
import { Platform } from 'react-native'
import Svg, { Text as SvgText } from 'react-native-svg'

// Inter-Regular.ttf: OS/2.sCapHeight = 1490, head.unitsPerEm = 2048.
// Center the capital glyph itself, without a native text line's descent space.
const INTER_CAP_HEIGHT = 1490 / 2048

/** The initial as an SVG element centred on (cx, cy), for use inside any <Svg>. */
export function PlayerInitialGlyph({ initial, cx, cy, fontSize }: { initial: string; cx: number; cy: number; fontSize: number }) {
  return (
    <SvgText
      x={cx}
      y={cy + fontSize * INTER_CAP_HEIGHT / 2}
      textAnchor="middle"
      fontFamily="Inter"
      fontWeight="700"
      fontSize={fontSize}
      fill="#fff"
    >
      {initial}
    </SvgText>
  )
}

export function PlayerInitial({ initial, size, fontSize = size * 0.42 }: { initial: string; size: number; fontSize?: number }) {
  return (
    <Svg width={size} height={size} {...(Platform.OS === 'web' ? { 'aria-hidden': true } : { accessible: false })}>
      <PlayerInitialGlyph initial={initial} cx={size / 2} cy={size / 2} fontSize={fontSize} />
    </Svg>
  )
}
